import { HttpRequestHub } from "../hub/HttpRequestHub";

export const GetFunc = (
  url: string,
  data = "",
  params?: any,
  enabled = true
) => {
  return HttpRequestHub({
    method: "GET",
    url: `${url}`,
    data,
    params: params ? params : undefined,
    enabled: enabled,
  });
};

export const DeleteFunc = (url: string, data?: any) => {
  const config = {
    method: "DELETE",
    url: `${url}`,
    data,
  };
  return HttpRequestHub(config);
};

export const CreateFunc = (url: string, data: any) => {
  const config = {
    method: "POST",
    url: `${url}`,
    data,
  };
  return HttpRequestHub(config);
};

export const EditFunc = (url: string, data: any, method = "PUT") => {
  const config = {
    method: method,
    url: `${url}`,
    data,
  };
  return HttpRequestHub(config);
};

export const GetFuncExcel = async (url: string) => {
  try {
    const response = await HttpRequestHub({
      method: "GET",
      url,
      responseType: "blob",
    });

    // Blobni qaytaramiz, lekin yuklab olmaymiz
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    return { response, blob };
  } catch (error) {
    console.error("Excel yuklab olishda xatolik:", error);
    throw error;
  }
};
